import script from "./TransferChangeTempWifiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferChangeTempWifiPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__